// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

body.cn-report-mode {
  overflow: auto !important;
}
body.cn-report-mode navigation,
body.cn-report-mode .navbar-static-side,
body.cn-report-mode topnavbar,
body.cn-report-mode .nav-header,
body.cn-report-mode .page-heading,
body.cn-report-mode .footer,
body.cn-report-mode footer,
body.cn-report-mode .loader-container,
body.cn-report-mode .reset-modal,
body.cn-report-mode .pdf-modal,
body.cn-report-mode app-cn-ai-sidebar,
body.cn-report-mode app-cn-ai-config,
body.cn-report-mode app-cn-report-popup,
body.cn-report-mode .pace,
body.cn-report-mode .pace-progress,
body.cn-report-mode .pace-activity {
  display: none !important;
}
body.cn-report-mode #wrapper,
body.cn-report-mode #page-wrapper {
  margin: 0 !important;
  padding: 0 !important;
}

@media print {
  body.cn-report-mode {
    width: auto !important;
    height: auto !important;
    overflow: visible !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  body.cn-report-mode #wrapper,
  body.cn-report-mode #page-wrapper,
  body.cn-report-mode .gray-bg,
  body.cn-report-mode .wrapper-content {
    display: block !important;
    position: static !important;
    overflow: visible !important;
    width: auto !important;
    height: auto !important;
    min-height: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    border: none !important;
    background: none !important;
  }
  html {
    height: auto !important;
    overflow: visible !important;
  }
  .pace,
  .pace-progress,
  .pace-activity {
    display: none !important;
    visibility: hidden !important;
    height: 0 !important;
    width: 0 !important;
    overflow: hidden !important;
  }
  .cn-report {
    display: block !important;
    width: auto !important;
    max-width: none !important;
    margin: 0 !important;
    padding: 0 !important;
    box-shadow: none !important;
    overflow: visible !important;
    background: #fff !important;
  }
  .cn-report,
  .cn-report * {
    print-color-adjust: exact !important;
  }
  .cn-report__stage-icon {
    color: #fff !important;
  }
  .cn-report__stage-icon--clarify {
    background-color: rgb(0, 173, 208) !important;
  }
  .cn-report__stage-icon--ideate {
    background-color: rgb(255, 121, 0) !important;
  }
  .cn-report__stage-icon--develop {
    background-color: rgb(105, 190, 40) !important;
  }
  .cn-report__stage-icon--implement {
    background-color: rgb(245, 67, 89) !important;
  }
  .cn-report__stage-title--clarify {
    color: rgb(0, 173, 208) !important;
  }
  .cn-report__stage-title--ideate {
    color: rgb(255, 121, 0) !important;
  }
  .cn-report__stage-title--develop {
    color: rgb(105, 190, 40) !important;
  }
  .cn-report__stage-title--implement {
    color: rgb(245, 67, 89) !important;
  }
  .cn-report__badge--converged {
    background-color: rgb(105, 190, 40) !important;
    color: #fff !important;
  }
  .cn-report__badge--diverged {
    background-color: #f1f1f2 !important;
    color: #6d6e71 !important;
  }
  .cn-report__accent-bar,
  .cn-report__footer-bar {
    background: linear-gradient(90deg, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%) !important;
  }
  .cn-report__card {
    background: #fafbfc !important;
  }
  @page {
    margin: 0.4in 0.5in;
    size: letter;
  }
}
.cn-report {
  max-width: 850px;
  margin: 30px auto;
  padding: 48px 56px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #676a6c;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}
.cn-report__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0;
}
.cn-report__title h1 {
  font-size: 24px;
  font-weight: 700;
  margin: 0 0 2px;
  color: #333;
  letter-spacing: -0.3px;
}
.cn-report__subtitle {
  font-size: 14px;
  color: #9e9e97;
  margin: 0;
  font-weight: 400;
}
.cn-report__branding {
  text-align: right;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}
.cn-report__logo {
  height: 36px;
  width: auto;
  display: block;
}
.cn-report__date {
  font-size: 11px;
  color: #9e9e97;
  letter-spacing: 0.2px;
}
.cn-report__accent-bar {
  height: 4px;
  margin: 16px 0 32px;
  background: linear-gradient(90deg, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%);
  border-radius: 2px;
}
.cn-report__stage {
  margin-bottom: 28px;
  page-break-inside: avoid;
}
.cn-report__stage-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
}
.cn-report__stage-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 700;
  color: #fff;
  flex-shrink: 0;
}
.cn-report__stage-icon--clarify {
  background: rgb(0, 173, 208);
}
.cn-report__stage-icon--ideate {
  background: rgb(255, 121, 0);
}
.cn-report__stage-icon--develop {
  background: rgb(105, 190, 40);
}
.cn-report__stage-icon--implement {
  background: rgb(245, 67, 89);
}
.cn-report__stage-title {
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  margin: 0;
}
.cn-report__stage-title--clarify {
  color: rgb(0, 173, 208);
}
.cn-report__stage-title--ideate {
  color: rgb(255, 121, 0);
}
.cn-report__stage-title--develop {
  color: rgb(105, 190, 40);
}
.cn-report__stage-title--implement {
  color: rgb(245, 67, 89);
}
.cn-report__card {
  background: #fafbfc;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  padding: 16px 20px;
  margin-bottom: 12px;
  page-break-inside: avoid;
}
.cn-report__card h4 {
  margin: 0;
}
.cn-report__card ul {
  margin: 0;
  padding: 0 0 0 20px;
}
.cn-report__card ul li {
  font-size: 13px;
  line-height: 1.7;
  margin-bottom: 2px;
}
.cn-report__card p {
  font-size: 13px;
  line-height: 1.7;
  margin: 0;
}
.cn-report__card-title {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #333;
  margin-bottom: 8px !important;
  padding-bottom: 6px;
  border-bottom: 1px solid #e7eaec;
}
.cn-report__label {
  font-weight: 600;
  color: #333;
}
.cn-report__badge {
  display: inline-block;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 2px 10px;
  border-radius: 3px;
  margin-bottom: 6px;
}
.cn-report__badge--converged {
  background: rgb(105, 190, 40);
  color: #fff;
}
.cn-report__badge--diverged {
  background: #f1f1f2;
  color: #6d6e71;
}
.cn-report__converged {
  margin-bottom: 12px;
}
.cn-report__diverged {
  margin-bottom: 12px;
}
.cn-report__grid-list {
  columns: 2;
  column-gap: 24px;
}
.cn-report__grid-list li {
  break-inside: avoid;
}
.cn-report__table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 12px;
  font-size: 12px;
}
.cn-report__table thead th {
  font-size: 11px;
  font-weight: 700;
  color: #676a6c;
  padding: 6px 12px;
  border: 1px solid #e7eaec;
  background: #fff;
  text-align: left;
}
.cn-report__table tbody td {
  padding: 6px 12px;
  border: 1px solid #e7eaec;
  vertical-align: top;
  line-height: 1.5;
}
.cn-report__table-group {
  font-size: 12px !important;
  font-weight: 700 !important;
  color: #333 !important;
  background: #f1f1f2 !important;
  letter-spacing: 0.3px;
}
.cn-report__footer {
  margin-top: 40px;
}
.cn-report__footer-bar {
  height: 3px;
  background: linear-gradient(90deg, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%);
  border-radius: 2px;
  margin-bottom: 12px;
}
.cn-report__footer-content {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  color: #9e9e97;
}
.cn-report__print-btn {
  position: fixed;
  bottom: 30px;
  right: 30px;
  background: #333;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  transition: background 0.2s;
}
.cn-report__print-btn i {
  margin-right: 6px;
}
.cn-report__print-btn:hover {
  background: #111;
}
@media print {
  .cn-report__print-btn {
    display: none !important;
  }
}
.cn-report__loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #676a6c;
}
.cn-report__loading-inner {
  text-align: center;
}
.cn-report__loading-inner i {
  font-size: 24px;
  color: rgb(105, 190, 40);
  margin-bottom: 12px;
  display: block;
}
.cn-report__loading-inner p {
  font-size: 14px;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/challenges/cn-report-full/cn-report-full.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AA5YA;EACC,yBAAA;AA+YD;AA7YC;;;;;;;;;;;;;;;;EAgBC,wBAAA;AA+YF;AA5YC;;EAEC,oBAAA;EACA,qBAAA;AA8YF;;AAzYA;EACC;IACC,sBAAA;IACA,uBAAA;IACA,4BAAA;IACA,oBAAA;IACA,qBAAA;EA4YA;EAzYA;;;;IAIC,yBAAA;IACA,2BAAA;IACA,4BAAA;IACA,sBAAA;IACA,uBAAA;IACA,wBAAA;IACA,oBAAA;IACA,qBAAA;IACA,uBAAA;IACA,2BAAA;EA2YD;EAvYD;IACC,uBAAA;IACA,4BAAA;EAyYA;EAtYD;;;IAGC,wBAAA;IACA,6BAAA;IACA,oBAAA;IACA,mBAAA;IACA,2BAAA;EAwYA;EArYD;IACC,yBAAA;IACA,sBAAA;IACA,0BAAA;IACA,oBAAA;IACA,qBAAA;IACA,2BAAA;IACA,4BAAA;IACA,2BAAA;EAuYA;EApYD;;IAGC,oCAAA;EAsYA;EAnYD;IACC,sBAAA;EAqYA;EApYA;IAAc,6CAAA;EAuYd;EAtYA;IAAc,6CAAA;EAyYd;EAxYA;IAAc,8CAAA;EA2Yd;EA1YA;IAAe,6CAAA;EA6Yf;EAzYA;IAAe,kCAAA;EA4Yf;EA3YA;IAAe,kCAAA;EA8Yf;EA7YA;IAAe,mCAAA;EAgZf;EA/YA;IAAe,kCAAA;EAkZf;EA9YA;IACC,8CAAA;IACA,sBAAA;EAgZD;EA9YA;IACC,oCAAA;IACA,yBAAA;EAgZD;EA5YD;;IAEC,mLAAA;EA8YA;EAtYD;IACC,8BAAA;EAwYA;EArYD;IACC,mBAAA;IACA,YAAA;EAuYA;AACF;AAnYA;EACC,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,wED7IY;EC8IZ,cD3GoB;EC4GpB,gBAAA;EACA,yCAAA;AAqYD;AAnYC;EACC,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,gBAAA;AAqYF;AAjYE;EACC,eAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;AAmYH;AA/XC;EACC,eAAA;EACA,cDzHsB;EC0HtB,SAAA;EACA,gBAAA;AAiYF;AA9XC;EACC,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,QAAA;AAgYF;AA7XC;EACC,YAAA;EACA,WAAA;EACA,cAAA;AA+XF;AA5XC;EACC,eAAA;EACA,cD9IsB;EC+ItB,qBAAA;AA8XF;AA3XC;EACC,WAAA;EACA,mBAAA;EACA,wKAAA;EASA,kBAAA;AAqXF;AAlXC;EACC,mBAAA;EACA,wBAAA;AAoXF;AAjXC;EACC,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAmXF;AAhXC;EACC,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;AAkXF;AAhXE;EAAc,4BDhNA;ACmkBhB;AAlXE;EAAc,4BDhND;ACqkBf;AApXE;EAAc,6BDhNA;ACukBhB;AAtXE;EAAe,4BDhNC;ACykBlB;AAtXC;EACC,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,SAAA;AAwXF;AAtXE;EAAe,uBD7ND;ACslBhB;AAxXE;EAAe,uBD7NF;ACwlBf;AA1XE;EAAe,wBD7ND;AC0lBhB;AA5XE;EAAe,uBD7NC;AC4lBlB;AA5XC;EACC,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;AA8XF;AA5XE;EAAK,SAAA;AA+XP;AA7XE;EACC,SAAA;EACA,mBAAA;AA+XH;AA7XG;EACC,eAAA;EACA,gBAAA;EACA,kBAAA;AA+XJ;AA3XE;EACC,eAAA;EACA,gBAAA;EACA,SAAA;AA6XH;AAzXC;EACC,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,WAAA;EACA,6BAAA;EACA,mBAAA;EACA,gCAAA;AA2XF;AAxXC;EACC,gBAAA;EACA,WAAA;AA0XF;AAvXC;EACC,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AAyXF;AAvXE;EACC,6BDxRa;ECyRb,WAAA;AAyXH;AAtXE;EACC,mBDzQmB;EC0QnB,cD7QkB;ACqoBrB;AApXC;EAAe,mBAAA;AAuXhB;AAtXC;EAAc,mBAAA;AAyXf;AAvXC;EACC,UAAA;EACA,gBAAA;AAyXF;AAxXE;EAAK,mBAAA;AA2XP;AAxXC;EACC,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AA0XF;AAxXE;EACC,eAAA;EACA,gBAAA;EACA,cDxSkB;ECySlB,iBAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;AA0XH;AAvXE;EACC,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AAyXH;AArXC;EACC,0BAAA;EACA,2BAAA;EACA,sBAAA;EACA,8BAAA;EACA,qBAAA;AAuXF;AApXC;EAAY,gBAAA;AAuXb;AArXC;EACC,WAAA;EACA,wKAAA;EASA,kBAAA;EACA,mBAAA;AA+WF;AA5WC;EACC,aAAA;EACA,8BAAA;EACA,eAAA;EACA,cD3UsB;ACyrBxB;AA3WC;EACC,eAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,wEDrYW;ECsYX,eAAA;EACA,0CAAA;EACA,aAAA;EACA,2BAAA;AA6WF;AA3WE;EAAI,iBAAA;AA8WN;AA7WE;EAAU,gBAAA;AAgXZ;AA/WE;EAnBD;IAmBgB,wBAAA;EAmXf;AACF;AAjXC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,wEDrZW;ECsZX,cDnXmB;ACsuBrB;AAhXC;EACC,kBAAA;AAkXF;AAhXE;EACC,eAAA;EACA,wBDvYa;ECwYb,mBAAA;EACA,cAAA;AAkXH;AA/WE;EAAI,eAAA;EAAiB,SAAA;AAmXvB","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './../../../../assets/styles/variables';\n\n// ─── Screen: hide sidebar/nav when in report mode ────\nbody.cn-report-mode {\n\toverflow: auto !important;\n\n\tnavigation,\n\t.navbar-static-side,\n\ttopnavbar,\n\t.nav-header,\n\t.page-heading,\n\t.footer,\n\tfooter,\n\t.loader-container,\n\t.reset-modal,\n\t.pdf-modal,\n\tapp-cn-ai-sidebar,\n\tapp-cn-ai-config,\n\tapp-cn-report-popup,\n\t.pace,\n\t.pace-progress,\n\t.pace-activity {\n\t\tdisplay: none !important;\n\t}\n\n\t#wrapper,\n\t#page-wrapper {\n\t\tmargin: 0 !important;\n\t\tpadding: 0 !important;\n\t}\n}\n\n// ─── Print ───────────────────────────────────────────\n@media print {\n\tbody.cn-report-mode {\n\t\twidth: auto !important;\n\t\theight: auto !important;\n\t\toverflow: visible !important;\n\t\tmargin: 0 !important;\n\t\tpadding: 0 !important;\n\n\t\t// Flatten all ancestors\n\t\t#wrapper,\n\t\t#page-wrapper,\n\t\t.gray-bg,\n\t\t.wrapper-content {\n\t\t\tdisplay: block !important;\n\t\t\tposition: static !important;\n\t\t\toverflow: visible !important;\n\t\t\twidth: auto !important;\n\t\t\theight: auto !important;\n\t\t\tmin-height: 0 !important;\n\t\t\tmargin: 0 !important;\n\t\t\tpadding: 0 !important;\n\t\t\tborder: none !important;\n\t\t\tbackground: none !important;\n\t\t}\n\t}\n\n\thtml {\n\t\theight: auto !important;\n\t\toverflow: visible !important;\n\t}\n\n\t.pace,\n\t.pace-progress,\n\t.pace-activity {\n\t\tdisplay: none !important;\n\t\tvisibility: hidden !important;\n\t\theight: 0 !important;\n\t\twidth: 0 !important;\n\t\toverflow: hidden !important;\n\t}\n\n\t.cn-report {\n\t\tdisplay: block !important;\n\t\twidth: auto !important;\n\t\tmax-width: none !important;\n\t\tmargin: 0 !important;\n\t\tpadding: 0 !important;\n\t\tbox-shadow: none !important;\n\t\toverflow: visible !important;\n\t\tbackground: #fff !important;\n\t}\n\n\t.cn-report,\n\t.cn-report * {\n\t\t-webkit-print-color-adjust: exact !important;\n\t\tprint-color-adjust: exact !important;\n\t}\n\n\t.cn-report__stage-icon {\n\t\tcolor: #fff !important;\n\t\t&--clarify  { background-color: $clarify-color !important; }\n\t\t&--ideate   { background-color: $ideate-color !important; }\n\t\t&--develop  { background-color: $develop-color !important; }\n\t\t&--implement { background-color: $implement-color !important; }\n\t}\n\n\t.cn-report__stage-title {\n\t\t&--clarify   { color: $clarify-color !important; }\n\t\t&--ideate    { color: $ideate-color !important; }\n\t\t&--develop   { color: $develop-color !important; }\n\t\t&--implement { color: $implement-color !important; }\n\t}\n\n\t.cn-report__badge {\n\t\t&--converged {\n\t\t\tbackground-color: $develop-color !important;\n\t\t\tcolor: #fff !important;\n\t\t}\n\t\t&--diverged {\n\t\t\tbackground-color: $color-neutral-light !important;\n\t\t\tcolor: $color-neutral-dark !important;\n\t\t}\n\t}\n\n\t.cn-report__accent-bar,\n\t.cn-report__footer-bar {\n\t\tbackground: linear-gradient(\n\t\t\t90deg,\n\t\t\t$clarify-color 25%, $ideate-color 25%,\n\t\t\t$ideate-color 50%, $develop-color 50%,\n\t\t\t$develop-color 75%, $implement-color 75%\n\t\t) !important;\n\t}\n\n\t.cn-report__card {\n\t\tbackground: #fafbfc !important;\n\t}\n\n\t@page {\n\t\tmargin: 0.4in 0.5in;\n\t\tsize: letter;\n\t}\n}\n\n// ─── Report Container ────────────────────────────────\n.cn-report {\n\tmax-width: 850px;\n\tmargin: 30px auto;\n\tpadding: 48px 56px;\n\tfont-family: $font-stack;\n\tcolor: $body-content-color;\n\tbackground: #fff;\n\tbox-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);\n\n\t&__header {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: flex-start;\n\t\tmargin-bottom: 0;\n\t}\n\n\t&__title {\n\t\th1 {\n\t\t\tfont-size: 24px;\n\t\t\tfont-weight: 700;\n\t\t\tmargin: 0 0 2px;\n\t\t\tcolor: #333;\n\t\t\tletter-spacing: -0.3px;\n\t\t}\n\t}\n\n\t&__subtitle {\n\t\tfont-size: 14px;\n\t\tcolor: $color-neutral-mid-old;\n\t\tmargin: 0;\n\t\tfont-weight: 400;\n\t}\n\n\t&__branding {\n\t\ttext-align: right;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: flex-end;\n\t\tgap: 4px;\n\t}\n\n\t&__logo {\n\t\theight: 36px;\n\t\twidth: auto;\n\t\tdisplay: block;\n\t}\n\n\t&__date {\n\t\tfont-size: 11px;\n\t\tcolor: $color-neutral-mid-old;\n\t\tletter-spacing: 0.2px;\n\t}\n\n\t&__accent-bar {\n\t\theight: 4px;\n\t\tmargin: 16px 0 32px;\n\t\tbackground: linear-gradient(\n\t\t\t90deg,\n\t\t\t$clarify-color 25%,\n\t\t\t$ideate-color 25%,\n\t\t\t$ideate-color 50%,\n\t\t\t$develop-color 50%,\n\t\t\t$develop-color 75%,\n\t\t\t$implement-color 75%\n\t\t);\n\t\tborder-radius: 2px;\n\t}\n\n\t&__stage {\n\t\tmargin-bottom: 28px;\n\t\tpage-break-inside: avoid;\n\t}\n\n\t&__stage-header {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 10px;\n\t\tmargin-bottom: 16px;\n\t}\n\n\t&__stage-icon {\n\t\tdisplay: inline-flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\twidth: 28px;\n\t\theight: 28px;\n\t\tborder-radius: 6px;\n\t\tfont-size: 12px;\n\t\tfont-weight: 700;\n\t\tcolor: #fff;\n\t\tflex-shrink: 0;\n\n\t\t&--clarify  { background: $clarify-color; }\n\t\t&--ideate   { background: $ideate-color; }\n\t\t&--develop  { background: $develop-color; }\n\t\t&--implement { background: $implement-color; }\n\t}\n\n\t&__stage-title {\n\t\tfont-size: 16px;\n\t\tfont-weight: 700;\n\t\ttext-transform: uppercase;\n\t\tletter-spacing: 0.8px;\n\t\tmargin: 0;\n\n\t\t&--clarify   { color: $clarify-color; }\n\t\t&--ideate    { color: $ideate-color; }\n\t\t&--develop   { color: $develop-color; }\n\t\t&--implement { color: $implement-color; }\n\t}\n\n\t&__card {\n\t\tbackground: #fafbfc;\n\t\tborder: 1px solid $color-grey-1;\n\t\tborder-radius: 6px;\n\t\tpadding: 16px 20px;\n\t\tmargin-bottom: 12px;\n\t\tpage-break-inside: avoid;\n\n\t\th4 { margin: 0; }\n\n\t\tul {\n\t\t\tmargin: 0;\n\t\t\tpadding: 0 0 0 20px;\n\n\t\t\tli {\n\t\t\t\tfont-size: 13px;\n\t\t\t\tline-height: 1.7;\n\t\t\t\tmargin-bottom: 2px;\n\t\t\t}\n\t\t}\n\n\t\tp {\n\t\t\tfont-size: 13px;\n\t\t\tline-height: 1.7;\n\t\t\tmargin: 0;\n\t\t}\n\t}\n\n\t&__card-title {\n\t\tfont-size: 12px;\n\t\tfont-weight: 700;\n\t\ttext-transform: uppercase;\n\t\tletter-spacing: 0.5px;\n\t\tcolor: #333;\n\t\tmargin-bottom: 8px !important;\n\t\tpadding-bottom: 6px;\n\t\tborder-bottom: 1px solid $color-grey-1;\n\t}\n\n\t&__label {\n\t\tfont-weight: 600;\n\t\tcolor: #333;\n\t}\n\n\t&__badge {\n\t\tdisplay: inline-block;\n\t\tfont-size: 10px;\n\t\tfont-weight: 700;\n\t\ttext-transform: uppercase;\n\t\tletter-spacing: 0.5px;\n\t\tpadding: 2px 10px;\n\t\tborder-radius: 3px;\n\t\tmargin-bottom: 6px;\n\n\t\t&--converged {\n\t\t\tbackground: $develop-color;\n\t\t\tcolor: #fff;\n\t\t}\n\n\t\t&--diverged {\n\t\t\tbackground: $color-neutral-light;\n\t\t\tcolor: $color-neutral-dark;\n\t\t}\n\t}\n\n\t&__converged { margin-bottom: 12px; }\n\t&__diverged { margin-bottom: 12px; }\n\n\t&__grid-list {\n\t\tcolumns: 2;\n\t\tcolumn-gap: 24px;\n\t\tli { break-inside: avoid; }\n\t}\n\n\t&__table {\n\t\twidth: 100%;\n\t\tborder-collapse: collapse;\n\t\tmargin-bottom: 12px;\n\t\tfont-size: 12px;\n\n\t\tthead th {\n\t\t\tfont-size: 11px;\n\t\t\tfont-weight: 700;\n\t\t\tcolor: $body-content-color;\n\t\t\tpadding: 6px 12px;\n\t\t\tborder: 1px solid $color-grey-1;\n\t\t\tbackground: #fff;\n\t\t\ttext-align: left;\n\t\t}\n\n\t\ttbody td {\n\t\t\tpadding: 6px 12px;\n\t\t\tborder: 1px solid $color-grey-1;\n\t\t\tvertical-align: top;\n\t\t\tline-height: 1.5;\n\t\t}\n\t}\n\n\t&__table-group {\n\t\tfont-size: 12px !important;\n\t\tfont-weight: 700 !important;\n\t\tcolor: #333 !important;\n\t\tbackground: $color-neutral-light !important;\n\t\tletter-spacing: 0.3px;\n\t}\n\n\t&__footer { margin-top: 40px; }\n\n\t&__footer-bar {\n\t\theight: 3px;\n\t\tbackground: linear-gradient(\n\t\t\t90deg,\n\t\t\t$clarify-color 25%,\n\t\t\t$ideate-color 25%,\n\t\t\t$ideate-color 50%,\n\t\t\t$develop-color 50%,\n\t\t\t$develop-color 75%,\n\t\t\t$implement-color 75%\n\t\t);\n\t\tborder-radius: 2px;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t&__footer-content {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tfont-size: 11px;\n\t\tcolor: $color-neutral-mid-old;\n\t}\n\n\t&__print-btn {\n\t\tposition: fixed;\n\t\tbottom: 30px;\n\t\tright: 30px;\n\t\tbackground: #333;\n\t\tcolor: #fff;\n\t\tborder: none;\n\t\tborder-radius: 8px;\n\t\tpadding: 12px 24px;\n\t\tfont-size: 14px;\n\t\tfont-weight: 600;\n\t\tfont-family: $font-stack;\n\t\tcursor: pointer;\n\t\tbox-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n\t\tz-index: 1000;\n\t\ttransition: background 0.2s;\n\n\t\ti { margin-right: 6px; }\n\t\t&:hover { background: #111; }\n\t\t@media print { display: none !important; }\n\t}\n\n\t&__loading {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tmin-height: 300px;\n\t\tfont-family: $font-stack;\n\t\tcolor: $body-content-color;\n\t}\n\n\t&__loading-inner {\n\t\ttext-align: center;\n\n\t\ti {\n\t\t\tfont-size: 24px;\n\t\t\tcolor: $develop-color;\n\t\t\tmargin-bottom: 12px;\n\t\t\tdisplay: block;\n\t\t}\n\n\t\tp { font-size: 14px; margin: 0; }\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
